import { routes } from "routes";
import { useTrendingCreators } from "queries";
import { UserListWidgetAlive } from "components/widgets/UserListWidgetAlive";
import { IUserInfo } from "./types";
import { IUser } from "services/types";

export const SuggestedCreators = () => {
  const creators = useTrendingCreators();

  if (creators.isError) {
    return <p>Error loading creators.</p>;
  }

  if (!creators.isSuccess || !creators.data || creators.data.length === 0) {
    return null;
  }

  const items = creators.data.map((el: IUser): IUserInfo => ({
    id: el.username,
    name: el.name ?? el.username,
    image: el.profileImageUrl ?? el.poster,
    verified: el.verified,
  }));

  return (
    <UserListWidgetAlive
      className="suggestedCreators"
      title="⚡️ Suggested Creators"
      link={routes.exploreCreators()}
      items={items}
    />
  );
};
